export const axisKey=(organization,device)=>'thrm-pressure-axis:'+JSON.stringify([organization||'',device]);
export function axisBounds(min,max){
 const parse=value=>typeof value==='number'?value:typeof value==='string'&&value.trim()?Number(value.trim().replace(',','.')):NaN;
 const low=parse(min),high=parse(max);
 return Number.isFinite(low)&&Number.isFinite(high)&&low<high?{min:low,max:high}:null;
}
export function readAxis(storage,key){try{const saved=JSON.parse(storage.getItem(key));return saved?axisBounds(saved.min,saved.max):null;}catch{return null;}}
export function writeAxis(storage,key,bounds){try{if(bounds)storage.setItem(key,JSON.stringify(bounds));else storage.removeItem(key);return true;}catch{return false;}}
export function outsideAxis(rows,raw,hidden,bounds){
 if(!bounds)return 0;
 let count=0;
 for(const row of rows)for(const value of (raw?row.samples:row.buckets)||[]){
  if(hidden.includes(value.channel_id))continue;
  const values=raw?[value.engineering_value]:value.count?[value.min,value.max]:[];
  if(values.some(v=>Number.isFinite(v)&&(v<bounds.min||v>bounds.max)))count++;
 }
 return count;
}
